var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.recognition_on ? 'is_on': 'is_off',attrs:{"id":"minimalMike"},on:{"click":_vm.toggle_microphone}},[_c('microphone-icon',{attrs:{"size":_vm.size,"is_on":_vm.recognition_on}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }